import React from 'react';

const DashboardPage: React.FC = () => {
  return (
    <div className="p-6 w-full min-h-screen bg-page-bg">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-blueprint-blue font-heading">Dashboard</h1>
        <p className="text-sm text-heritage-grey mt-1">Analytics and insights — coming soon</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[
          { label: 'Total Proposals', placeholder: '—' },
          { label: 'Total Revenue', placeholder: '—' },
          { label: 'Win Rate', placeholder: '—' },
        ].map(card => (
          <div key={card.label} className="bg-white rounded-xl shadow-card p-6">
            <p className="text-sm text-heritage-grey">{card.label}</p>
            <p className="text-3xl font-bold text-heritage-grey/40 mt-2">{card.placeholder}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl shadow-card p-8 text-center">
        <svg className="w-12 h-12 text-heritage-grey/40 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
        <h2 className="text-lg font-semibold text-heritage-grey mb-2">Dashboard under construction</h2>
        <p className="text-sm text-heritage-grey max-w-md mx-auto">
          This page will show proposal analytics, revenue trends, win/loss rates, and product breakdown insights once enough data is available.
        </p>
      </div>
    </div>
  );
};

export default DashboardPage;
